import { makeStyles } from "@mui/styles";

export default makeStyles(() => {
  return {
    coverLayout: {
      minHeight: "100vh",
      margin: 0,
      backgroundColor: "white",
    },

    formContainer: {
      maxWidth: "400px",
      margin: "0 auto",
      padding: "2rem",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },

    coverLayout_imageBox: {
      height: "90vh",
      overflow: "hidden",
      borderRadius: "1rem",
      background: ({ image }) => `url(${image}) center/cover no-repeat`,
      position: "relative",
      margin: "2rem",
      display: "flex",
      alignItems: "center",
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.9,
        background: "linear-gradient(135deg, #1a2035 0%, transparent 50%)",
      },
    },

    coverLayout_image: {
      position: "relative",
      zIndex: 1,
      width: "100%",
      height: "100%",
      padding: "3rem",
    },

    titleContainer: {
      position: "relative",
      maxWidth: "600px",
      marginTop: "2rem",
      marginLeft: "2rem",
      "& h1, & h2, & span": {
        color: "#ffffff !important",
      },
    },

    mainTitle: {
      fontSize: "3.5rem !important",
      lineHeight: "1.2 !important",
      marginBottom: "1rem !important",
    },

    subtitle: {
      fontSize: "2.5rem !important",
      lineHeight: "1.4 !important",
      marginBottom: "0.5rem !important",
    },

    logo: {
      display: "flex",
      justifyContent: "left",
      marginBottom: "1rem",
      "& img": {
        width: "200px",
        height: "auto",
      },
    },
  };
});
